import { TextCell } from "../cells";

export const recordDateColumn = {
  label: <TextCell emphasis="medium">Record</TextCell>,
  width: "1fr",
  cell: (event: { recordDate: string }) => (
    <TextCell emphasis="medium">{event.recordDate || "-"}</TextCell>
  ),
};
